import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import "./RecruiterCandidateHistory.css"
import CreateIcon from '@mui/icons-material/Create';
import canReqRecruiterhistory from '../../apis/candidateRequsitionHistory/candidateRequsitionHistory';
import { NotificationContainer, NotificationManager } from "react-notifications";
import { DateTime } from "luxon";
import PostAddIcon from '@mui/icons-material/PostAdd';
import HistoryIcon from '@mui/icons-material/History';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const RecruiterCandidateHistory = ({open,onClose , recruitmentpartnerId , canReqId}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const payload = { recruitmentpartnerId, candidaterequisitionsId:canReqId }
        const resp = await canReqRecruiterhistory(payload)
        setData(resp?.data || [])
      }
      catch (e) {
        NotificationManager.error("No data available", "Error", 10000);
      } finally{
        setLoading(false);
      }
    }

    if (recruitmentpartnerId && canReqId) {
      fetchData()
    }
  }, [])



  const getDateTimeDesp = (obj) => {

    let hist = obj.recEmail

    if (obj?.createdBy)
      hist = obj?.recEmail + " created  stage " + obj.status + " "
    else
      hist = obj?.recEmail + " updated fields : " + obj.field.join(", ").toLowerCase() + " on stage " + obj.status

    const dateTime = DateTime.fromISO(obj.date)

    const date = dateTime.toFormat('dd LL yyyy');
    const time = dateTime.toFormat('hh:mm a');

    return { hist, date, time }

  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullScreen >
      <DialogTitle className='dialogTitleContainer_candiHistory'>
        <div className='leftSection_candiHistory'>
          <HistoryIcon className='historyIcon' />
          <div className='mainTitle_candiHistory'>Candidate History</div>
        </div>

      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" alignItems="center" justifyContent="center" minHeight={160}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {data && data.length > 0 ? (
              data.map((obj, index) => {
                const { hist, date, time } = getDateTimeDesp(obj);
                return (
                  <div className='canreq_history_container' key={index + "_canreq_history"}>
                    <div className='history_date'>
                      <p>{time}</p>
                      <p>{date}</p>
                    </div>
                    <div className='icon_line'>
                      <Box className="historyLine" />
                      <div className='icon_container'>
                        {!obj.createdBy ?
                          <CreateIcon className='history_Icons' /> :
                          <PostAddIcon className='history_Icons' />
                        }
                      </div>
                    </div>
                    <Typography variant="body2">{hist}</Typography>
                    <Divider sx={{ my: 1 }} />
                  </div>
                )
              })
            ) : (
              <Box py={5} className="noHistory" >No history found.</Box>
            )}
          </>
        )}
        <NotificationContainer />
      </DialogContent>
      <DialogActions>
        <button
          variant="outlined"
          className="cancelButton_bulkSubmit"
          onClick={onClose}
        >
          <ArrowBackIcon className="buttonIcon_bulkSubmit" />
          <span>Go back</span>
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default RecruiterCandidateHistory;
